import React from 'react';
import { IconAlertTriangle } from '@tabler/icons-react';
import { AUDIT_PILL_BG, AUDIT_PILL_BORDER, AUDIT_PILL_TEXT, AUDIT_LABEL } from '../lib/notificationSeverity';

// Issue #246. The severity marker for an `audit` notification, rendered by all three
// consuming surfaces — Topbar.js's bell dropdown, NotificationOverlay.js's mobile sheet
// and NotificationsPage.js's list. Carries its own icon so it survives a greyscale screen
// and does not depend on colour alone to read as an exception.
//
// Its own file rather than a nested definition: a component defined inside a parent's body
// remounts on every render, which is a recurring defect in this codebase and the reason
// that pattern is a locked rule.
export default function AuditPill({ compact = false }) {
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4, flexShrink: 0,
      fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px',
      padding: compact ? '1px 6px' : '2px 7px', borderRadius: 999,
      background: AUDIT_PILL_BG, border: `1px solid ${AUDIT_PILL_BORDER}`, color: AUDIT_PILL_TEXT,
    }}>
      <IconAlertTriangle size={11} aria-hidden="true" />
      {AUDIT_LABEL}
    </span>
  );
}
